import { render } from "./Sv022.vue?vue&type=template&id=3a244ae5&scoped=true"
import script from "./Sv022.vue?vue&type=script&lang=js"
export * from "./Sv022.vue?vue&type=script&lang=js"

import "./Sv022.vue?vue&type=style&index=0&id=3a244ae5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a244ae5"]])

export default __exports__